
export default function PDFViewer({ PDF }) {
    return <embed
        src={PDF}
        type="application/pdf"
        width={"100%"}
        height={"100%"}
    />
}